module.exports = __webpack_public_path__ + "static/media/Gourgeist_gaussian2.3859e12f.png";